module.exports = {"TXTWCL_Popular_Accumulators":{"id":"TXTWCL_Popular_Accumulators","defaultMessage":"Combinés populaires","ontario":"Combinés populaires"}}